module.exports = __webpack_public_path__ + "static/media/smallRabbit_800.7e129e01.png";